import { Link } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { Link as RouterLink } from 'react-router-dom';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { LinkTarget } from 'core/enums';
import { getAgGridTableCellData } from 'core/utils';
import { quotePartsPath } from 'quotes/routes/routePaths';

interface IProps extends ICellRendererParams {
  target?: LinkTarget;
}

const QuoteIdCell = ({ value, target = LinkTarget.SELF, ...props }: IProps) => {
  const data = getAgGridTableCellData({ ...props, value }, 'quoteId');
  if (!data) {
    return value;
  }

  if (!value) {
    return DEFAULT_PLACEHOLDER;
  }

  return (
    <Link component={RouterLink} to={quotePartsPath(value)} target={target} fontSize={14}>
      {value}
    </Link>
  );
};

export default QuoteIdCell;
